/**
 * AssignTile — Compact home tile that surfaces the Assign-task flow.
 */
import { Send } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function AssignTile() {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/assign")}
      style={{ touchAction: "manipulation" }}
      className="w-full flex items-center gap-3 rounded-2xl border bg-card hover:bg-accent transition-colors p-3 sm:p-4 text-left shadow-sm hover:shadow-md active:scale-[0.99]"
    >
      <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center flex-shrink-0 shadow-md">
        <Send className="h-5 w-5 text-primary-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-foreground">Assign a task</p>
        <p className="text-xs text-muted-foreground truncate">
          Send a small step to family or circle.
        </p>
      </div>
    </button>
  );
}

export default AssignTile;
